
/** For widget settings */
export enum CustomerSatisfactionMetric {
  topline = 'topline',
  physical = 'physical',
  digital = 'digital',
  support = 'support',
  service = 'service',
}
